// v0 OAuth Connect button — scaffolded by INTEGRATIONS per
// MARKETPLACE tick-4 REQUEST. Replaces `SecretField` when the kind's
// `ui_flow === 'oauth2'` (already hidden by that guard). Button click
// calls the registered `startOAuthFlow(kind, {scopeType, scopeId, slug})`
// function which opens the provider's OAuth URL + handles the
// callback → Vault persistence. Today `startOAuthFlow` is a stub that
// throws a clear "not wired" error; DOMAIN's first OAuth2 provider
// (Cloudflare registrar) triggers the full implementation.

export const MarketplaceOAuthConnectButton = {
  extends: 'Button',
  theme: 'primary',
  marginTop: 'Z',
  text: (el, s) => `Connect with ${s?.kindLabel || s?.kind || 'provider'}`,
  disabled: (el, s) => !!s?.oauthInFlight,
  onClick: (e, el, s) => el.call('startOAuthFlow', s?.kind, {
    scopeType: s?.scopeType,
    scopeId: s?.scopeId,
    slug: s?.slug
  })
}
